import { Divider } from "@mui/material";
import Grid from '@mui/material/Grid2';
import { EmptyRow } from "../../../components/datalist/EmptyRow";
import { TFunction } from "i18next";
import { passwordButtonStyles, signInGridStyles } from "../styles";
import { CredentialContainer } from "../../../api/representations";
import { TFuncKey } from "../../../i18n";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import Button from "../../../components/button/Button";
import { KeycloakLoginOptions } from "libs/keycloak-js/lib/keycloak";

interface PasswordNotSetupProps {
    t: TFunction;
    container: CredentialContainer;
    accountType: string;
    login: (options?: KeycloakLoginOptions | undefined) => Promise<void>;
}

export default function PasswordNotSetup({ t, container, accountType, login }: PasswordNotSetupProps) {
    return (
        <>
          <Divider />
          <Grid container sx={signInGridStyles}>
            <Grid container alignItems="center">
              <EmptyRow
                message={t("notSetUp", {
                  name: t(container.displayName as TFuncKey),
                })}
                data-testid={`${container.type}/not-set-up`}
                endAddon={<InfoOutlinedIcon color="error" />}
              />
            </Grid>
            <Grid sx={{ alignSelf: 'center' }}>
              {container.createAction && accountType != "CORPORATE" && (
                <Button
                  variant="contained"
                  size="small"
                  sx={passwordButtonStyles}
                  onClick={() => login({ action: container.createAction })}
                  data-testid={`${container.type}/create`}
                >
                  {t("setUpNew", {name: t('password-display-name').toLowerCase()})}
                </Button>
              )}
            </Grid>
          </Grid>
        </>
    );
}